if (!customElements.get('mke-catalog')) {
  customElements.define('mke-catalog', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.cards = [...this.querySelectorAll('[data-mc-type]')];
      this.buttons = [...this.querySelectorAll('[data-mc-filter]')];
      this.search = this.querySelector('input[type="search"]');
      this.activeType = 'all';
      this.querySelector('[data-mc-all]').textContent = this.cards.length;
      this.querySelector('.mc-filter-group').hidden = false;
      this.querySelector('.mc-search').hidden = false;
      this.querySelectorAll('[data-mc-total]').forEach(e => { e.textContent = this.cards.filter(c => this.matchesCategory(c, e.dataset.mcTotal)).length; });
      this.buttons.forEach(b => b.addEventListener('click', () => { this.activeType = b.dataset.mcFilter; this.applyFilters(); const url = new URL(location.href); url.searchParams.set('gear', this.activeType); url.hash = 'new-gear'; history.replaceState(null, '', url); }));
      this.search.addEventListener('input', () => this.applyFilters());
      const initial = new URLSearchParams(location.search).get('gear');
      if (['all', 'tees', 'hoodies', 'crewnecks', 'takeover'].includes(initial)) this.activeType = initial;
      this.querySelectorAll('.mc-rail-controls').forEach(e => { e.hidden = false; });
      this.querySelectorAll('[data-mc-scroll]').forEach(b => b.addEventListener('click', () => {
        const rail = b.closest('.mc-department').querySelector('.mc-rail');
        rail.scrollBy({left: rail.clientWidth * Number(b.dataset.mcScroll) * .85, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }));
      this.applyFilters();
    }
    matchesCategory(card, category) {
      return category === 'all' || card.dataset.mcType === category || card.dataset.mcCollection === category;
    }
    applyFilters() {
      const term = this.search.value.trim().toLowerCase();
      let count = 0;
      this.cards.forEach(card => {
        const show = this.matchesCategory(card, this.activeType) && card.dataset.mcTitle.toLowerCase().includes(term);
        card.hidden = !show;
        if (show) count++;
      });
      this.classList.toggle('is-takeover', this.activeType === 'takeover');
      this.querySelector('[data-mc-takeover-heading]').hidden = this.activeType !== 'takeover';
      this.classList.toggle('is-filtered', this.activeType !== 'all' || term !== '');
      this.querySelectorAll('.mc-department').forEach(group => {
        group.querySelector('.mc-rail').scrollLeft = 0;
        group.hidden = ![...group.querySelectorAll('[data-mc-type]')].some(card => !card.hidden);
      });
      this.buttons.forEach(b => { const active = b.dataset.mcFilter === this.activeType; b.classList.toggle('is-active', active); b.setAttribute('aria-pressed', String(active)); });
      this.querySelector('[data-mc-count]').textContent = count;
      const countLabel = this.querySelector('[data-mc-count-label]');
      countLabel.textContent = count === 1 ? countLabel.dataset.singular : countLabel.dataset.plural;
      this.querySelector('.mc-empty').hidden = count !== 0;
    }
  });
}
